// Import model
import { ContentResultCondition } from '../models/ContentResultCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ContentResultIndexedFields } from '../models/ContentResultIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ContentResultIndexedFieldsSerializer } from './ContentResultIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ContentResultCondition - handles JSON serialization and deserialization with type validation
 */
export class ContentResultConditionSerializer {
  /**
   * Deserializes a JSON string into a ContentResultCondition instance
   */
  static deserialize(json: string): ContentResultCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ContentResultCondition instance
   */
  static fromObject(obj: any): ContentResultCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ContentResultCondition');
    }


    const instance: ContentResultCondition = {
      fieldName: obj['fieldName'] as ContentResultIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ContentResultCondition instances
   */
  static deserializeArray(json: string): ContentResultCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ContentResultCondition instance to a JSON string
   */
  static serialize(instance: ContentResultCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ContentResultCondition instance to a plain object
   */
  static toObject(instance: ContentResultCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ContentResultCondition instances to a JSON string
   */
  static serializeArray(instances: ContentResultCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
